module.exports = __webpack_public_path__ + "img/dat.55cb0c2b.svg";